
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { GridValueGetterParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import MasterComponent from '../../common/MasterComponent';
import { digitalTwinActions } from '../../store/reducers/digital-twin';
import { useDispatch } from 'react-redux';
import FactoryUseCaseFormModal from '../../common/factoryUseCaseFormModal';
import { digitalTwinSchema, digitalTwinUISchema } from './form';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import PopUp from '../../components/Popup';
import { get } from 'lodash';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';

export const digitalTwinDefaultFields = {
    dt_name: '',
    onto_manage_id: null,
};

const getAlertData: any = {
    add: {
        icon: <SuccessIcon />,
        msg: 'New Digital Twin Data Added',
    },
    update: {
        icon: <SuccessIcon />,
        msg: 'Digital Twin Data Updated Successfully!',
    },
    deleteSuccess: {
        icon: <SuccessIcon />,
        msg: 'Digital Twin Data Deleted Successfully!',
    },
    delete: {
        icon: <AlertIcon />,
        msg: 'Are you sure to delete this Digital Twin?',
    },
};

const DigitalTwin = ({isDigitalTwinLoading, digitalTwinList, digitalTwinDataTotalCount, digitalTwinPageNumber, searchItem, ontologyData, ontologyMgmntData, isAddDigitalTwinSuccess, isUpdateDigitalTwinSuccess, isRemoveDigitalTwinSuccess }: any) => {
    const [isModalOpen, setIsModalOpen] = useState<any>(false);
    const [isEdit, setIsEdit] = useState<any>(false);
    const [digitalTwinDataList, setDigitalTwinDataList] = useState<any>([])
    const [digitalTwinData, setDigitalTwinData] = useState<any>(digitalTwinDefaultFields);
    const [editOntoData, setEditOntoData] = useState<any>([]);
    const [deletableFactory, setDeletableFactory] = useState<any>({});
    const [alertPopup, setAlertPopup] = useState<any>({ isOpen: false, type: '' });
    const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const dispatchDigitalTwinRequest = (payload: any) => {        
        dispatch(
            digitalTwinActions.getDigitalTwinListRequest({
                search_item: searchItem,
                ...payload
            })
        );
    };

    useEffect(() => {
        dispatchDigitalTwinRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
        });
        dispatch(ontologyMasterActions.getOntologyList(''));
        dispatch(ontologyMasterActions.getOntologyMgmntList(''));

        return () => {
            dispatch(digitalTwinActions.resetDigitalTwinsData());
        };
    }, []);

    useEffect(() => {
        if (digitalTwinList && digitalTwinList.length > 0) {
            setDigitalTwinDataList(
                digitalTwinList.map((item: any) => {
                    return {
                        ...item,
                        ontologyList: getOntologyData(item.onto_manage_id),
                        id: item.dt_id,
                    };
                })
            );
        } else {
            setDigitalTwinDataList([])
        }
    }, [digitalTwinList, ontologyMgmntData]);

    useEffect(() => {       
        if (isAddDigitalTwinSuccess || isUpdateDigitalTwinSuccess || isRemoveDigitalTwinSuccess) {
            dispatchDigitalTwinRequest({
                limit: DEFAULT_PAGE_SIZE,
                page:
                isRemoveDigitalTwinSuccess && digitalTwinDataList.length === 1 && digitalTwinPageNumber !== 1
                        ? digitalTwinPageNumber - 1
                        : digitalTwinPageNumber                
            });
        }

    }, [
        isAddDigitalTwinSuccess,
        isUpdateDigitalTwinSuccess,
        isRemoveDigitalTwinSuccess,
        dispatch,
    ]);

    const getOntologyData = (ontoId: any) => {
        if (ontologyMgmntData.length > 0) {
          let tempOntoData: any = [];
          restartTheLoop: while (true) {
            for (const item of ontologyMgmntData) {
              if (item.onto_manage_id == ontoId) {
                tempOntoData.unshift(item);
                ontoId = item.parent_id;
                continue restartTheLoop;
              }
            }
            break;
          }
    
          tempOntoData.map((item: any) => {
            let getLevelName = ontologyData.filter((data: any) => {
              return data.id === item.onto_level_number;
            })[0];
    
            return {
              ...item,
              level_name: getLevelName?.level_name || '',
            };
          });
          return tempOntoData;
        }
        return [];
      };

    const columns: any = [
        {
            field: 'dt_name',
            headerName: 'Digital twin name',
            flex: 1,
            minWidth: 200,
            sortable: true,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.value} placement='bottom' arrow>
                        <Typography
                            component='p'
                            variant='subtitle1'
                            sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                        >
                            {params.value}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: 'onto_manage_id',
            headerName: 'Ontology',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 100,
            sortable: true,
            renderCell: (params: any) => {
                const ontoList =
                  params.row.ontologyList && params.row.ontologyList.length
                    ? params.row.ontologyList.map((item: any, index: number) =>
                        params.row.ontologyList.length > 1 ? (
                          index === params.row.ontologyList.length - 1 ? (
                            <span key={index}>{item.onto_manage_title} </span>
                          ) : (
                            <span  key={index}>{item.onto_manage_title} / </span>
                          )
                        ) : (
                          <span  key={index}>{item.onto_manage_title}</span>
                        )
                      )
                    : '';
        
                return (                 
                  <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '250px' }}>
                    <Tooltip title={ontoList} placement='left' arrow>
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                      >
                      {ontoList}
                      </Typography>
                      </Tooltip>
                    {/* <Tooltip title={params.value} placement='left' arrow>
                      <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                      >
                      {ontoList}
                      </Typography>
                    </Tooltip>                            */}
                  </Box>
                );
              },
        },
        {
            field: 'created_date',
            headerName: 'Created/Modified Date',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 100,
            sortable: false,
        },

    ];

    const handleEdit = (row: any) => {
        let ontoId = row.onto_manage_id;
        if (ontologyMgmntData.length > 0) {
            let tempOntoData: any = [];
            restartTheLoop: while (true) {
                for (const item of ontologyMgmntData) {
                    if (item.onto_manage_id == ontoId) {
                        tempOntoData.unshift(item);
                        ontoId = item.parent_id;
                        continue restartTheLoop;
                    }
                }
                break;
            }

            setEditOntoData(
                tempOntoData.map((item: any) => {
                    let getLevelName = ontologyData.filter((data: any) => {
                        return data.id === item.onto_level_number;
                    })[0];
                    return {
                        ...item,
                        level_name: getLevelName?.level_name || '',
                    };
                })
            );
        }
        setIsEdit(true);
        setDigitalTwinData(row);
        setIsModalOpen(true);
    };


    const handleDelete = () => {
        dispatch(digitalTwinActions.removeDigitalTwinRequest(get(deletableFactory, 'dt_id', '')));
        setDigitalTwinData({});
        setAlertPopup({ isOpen: false, type: '' });
    };

    const handleTwinActions = (item:any,appMode:any) => {        
        navigate(`${'/digital-twin/' + item.dt_id +'/'+appMode}`);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setIsEdit(false);
        setDigitalTwinData(digitalTwinDefaultFields);
    };

    const onSave = (payload: any) => {
        if (isEdit) {            
            dispatch(digitalTwinActions.updateDigitalTwinRequest(payload));
        } else {
            dispatch(digitalTwinActions.addDigitalTwinRequest(payload));
        }
    };

    const renderFormModal = () => (
        <FactoryUseCaseFormModal
            title={`${isEdit ? 'EDIT' : 'ADD NEW'} DIGITAL TWIN`}
            isModalOpen={isModalOpen}
            data={digitalTwinData}
            setData={setDigitalTwinData}
            tags={[]}
            setTags={() => { }}
            ontologyData={ontologyData}
            isEdit={isEdit}
            closeModal={closeModal}
            onSave={onSave}
            uiSchema={digitalTwinUISchema}
            dataSchema={digitalTwinSchema}
            metaDataSchema={[]}
            isFrom='digitalTwin'
            editOntoData={editOntoData}
        />
    );

    const renderAlertPopup = () => {
        const alertData = getAlertData[alertPopup.type];
        const isDelete = alertPopup.type === 'delete';

        const onClosePopup = () => {
            if (isDelete) {
                setDeletableFactory({});
            } else {
                setIsEdit(false);
                setDigitalTwinData({});
            }
            setAlertPopup({ isOpen: false, type: '' });
        };

        return (
            <PopUp
                open={alertPopup.isOpen}
                icon={get(alertData, 'icon')}
                message={get(alertData, 'msg')}
                cancel={isDelete}
                confirmation={true}
                cancelLabel='No'
                confirmLabel={isDelete ? 'Yes' : 'Ok'}
                onConfirm={() => {
                    if (isDelete) {
                        handleDelete();
                    } else {
                        setAlertPopup({ isOpen: false, type: '' });
                    }
                }}
                onClose={onClosePopup}
                onCancel={onClosePopup}
            />
        );
    };

    // console.log('sortingModel',sortingModel)
    
    return (
        <><MasterComponent
            heading='List of Digital Twin'
            isLoading={isDigitalTwinLoading}
            rows={digitalTwinDataList}
            columns={columns}
            isServerPagination
            totalRowCount={digitalTwinDataTotalCount}
            pageNumber={digitalTwinPageNumber}
            onSorting={(sortModel: { field: string; sort: string }) => {                                
                dispatchDigitalTwinRequest({
                    limit: DEFAULT_PAGE_SIZE,
                    page: DEFAULT_PAGE_NUMBER,
                    ...sortModel,
                });
                setSortingModel(sortModel);               
              }}
            onPagination={(pageSize: number, pageNumber: number) => {
                dispatchDigitalTwinRequest({
                    limit: pageSize,
                    page: pageNumber,
                });
            }}
            setIsModalOpen={setIsModalOpen}
            noRowsOverlay={() => (
                <Stack height='100%' alignItems='center' justifyContent='center'>
                    Digital twin data not available
                </Stack>
            )}
            actionsColumn={{

                edit: {
                    onClick: (params: GridValueGetterParams) => handleEdit(params.row),
                },
                delete: {
                    onClick: (params: GridValueGetterParams) => {
                        setDeletableFactory(get(params, 'row', {}));
                        setAlertPopup({ isOpen: true, type: 'delete' });
                    },
                },
                play: {
                    onClick: (params: GridValueGetterParams) => handleTwinActions(get(params, 'row', {}),'player'),
                },
                editDigitalTwin: {
                    onClick: (params: GridValueGetterParams) => handleTwinActions(get(params, 'row', {}),'editor'),
                },
            }}
            showSearch
            searchPlaceholder='Name / Ontology'
            onSearch={(searchValue: string) => {
                dispatchDigitalTwinRequest({
                    limit: DEFAULT_PAGE_SIZE,
                    page: DEFAULT_PAGE_NUMBER,
                    search_item: searchValue,
                });
                let sd:any = searchValue;
                dispatch(digitalTwinActions.onSearchForItem(sd));
            }}
        />
            {renderFormModal()} {renderAlertPopup()}</>

    )
}

const mapStateToProps = (state: any) => ({
    ontologyData: state.ontologyMaster.ontologyData,
    ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
    isDigitalTwinLoading : state.digitalTwin.isDigitalTwinLoading,
    digitalTwinList: state.digitalTwin.digitalTwinList,
    isAddDigitalTwinSuccess: state.digitalTwin.isAddDigitalTwinSuccess,
    isUpdateDigitalTwinSuccess: state.digitalTwin.isUpdateDigitalTwinSuccess,
    isRemoveDigitalTwinSuccess: state.digitalTwin.isRemoveDigitalTwinSuccess,
    digitalTwinDataTotalCount: state.digitalTwin.digitalTwinTotalCount,
    digitalTwinPageNumber: state.digitalTwin.digitalTwinPageNumber,
    searchItem: state.digitalTwin.searchItem,
});

export default connect(mapStateToProps)(DigitalTwin);